// modules/tenant-builder/steps/TemplateStep.tsx

import React from 'react';
import { Tenant } from '../../../core/types';
import { Check } from 'lucide-react';

import { TEMPLATES } from '../../../templates';

interface Props {
  data: Partial<Tenant>;
  onChange: (updates: Partial<Tenant>) => void;
}

export const TemplateStep: React.FC<Props> = ({ data, onChange }) => {
  const selectedTemplate = data.templateId || 'pousada-classica';

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-3 gap-6">
        {TEMPLATES.map((template) => (
          <div
            key={template.id}
            onClick={() => onChange({ templateId: template.id })}
            className={`border-2 rounded-xl p-4 cursor-pointer transition-all ${
              selectedTemplate === template.id
                ? 'border-blue-600 bg-blue-50 shadow-lg'
                : 'border-gray-200 hover:border-blue-300 hover:shadow-md'
            }`}
          >
            {/* Thumbnail placeholder */}
            <div className="aspect-video bg-gradient-to-br from-gray-100 to-gray-200 rounded-lg mb-4 flex items-center justify-center">
              <span className="text-4xl">🏞️</span>
            </div>

            <div className="flex items-start justify-between mb-2">
              <div>
                <h3 className="font-bold text-lg">{template.name}</h3>
                <p className="text-sm text-gray-600">{template.description}</p>
              </div>
              {selectedTemplate === template.id && (
                <div className="bg-blue-600 text-white rounded-full p-1">
                  <Check size={16} />
                </div>
              )}
            </div>

            {template.isPremium && (
              <div className="inline-block bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded-full mb-2">
                ⭐ Premium
              </div>
            )}

            <ul className="space-y-1 mt-3">
              {template.features.map((feature, idx) => (
                <li key={idx} className="text-xs text-gray-600 flex items-center gap-2">
                  <Check size={12} className="text-green-500" />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
        <p className="text-sm text-purple-800">
          ✨ <strong>Personalização ilimitada:</strong> Você poderá personalizar cores, fontes e layout depois!
        </p>
      </div>
    </div>
  );
};
